export default __webpack_public_path__ + "static/b1-aad7122ee59aa4a3d5a286f1eab5cea4.jpg";